var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"informazioni-legali"},[_vm._v(" Partita IVA: 03513050264 ")])}
var staticRenderFns = []

export { render, staticRenderFns }